
function getVarId (item) {
  var id = [item.id]
  return id
}

const incomeDict = [
  { 'id': 'r2248', 'label': 'Less than 30 000$' },
  { 'id': 'r2249', 'label': '30 000$ to 60 000$' },
  { 'id': 'r2250', 'label': '60 000$ a 90 000$' },
  { 'id': 'r2251', 'label': '90 000$ a 120 000$' },
  { 'id': 'r2252', 'label': 'More than 120 000$ ' }
]
const ageGroupDict = [
  { 'id': 'r2253', 'label': 'Younger than 15 yrs old' },
  { 'id': 'r2254', 'label': 'Between 15 and 30 yrs old' },
  { 'id': 'r2255', 'label': 'Between 30 and 45 yrs old' },
  { 'id': 'r2256', 'label': 'Between 45 and 60 yrs old' },
  { 'id': 'r2257', 'label': 'Older than 60yrs old' }
]

const ageVariables = ageGroupDict.map(getVarId)
const revenueVariables = incomeDict.map(getVarId)

export default {
  incomeDict,
  ageGroupDict,
  layers: {
    customers: {
      viz: null,
      table: null
    },
    demographic: {
      viz: null,
      table: null, // dynamique selon zoom
      zoomParams: [
        { table: 'demo2016_pr', minZoom: 0, label: 'province' },
        { table: 'demo2016_dr', minZoom: 2, label: 'censusDiv' },
        { table: 'demo2016_sdr', minZoom: 4, label: 'censusSubDiv' },
        { table: 'demo2016_rta', minZoom: 6, label: 'forwardSortArea' },
        { table: 'demo2016_ad', minZoom: 10, label: 'dissArea' }
      ],
      variables: ['r1', 'r39', 'r102', 'r742', 'r6', 'r1683', 'r1686'],
      geoLabel: {
        demo2016_ad: ['rta_name', 'sdr_name', 'dr_name', 'pr_name'],
        demo2016_rta: ['sdr_name', 'dr_name', 'pr_name'],
        demo2016_sdr: ['dr_name', 'pr_name'],
        demo2016_dr: ['pr_name'],
        demo2016_pr: ['name_geo as ng']
      }
    },
    statistics: {
      viz: `
      resolution : 64     
      color: opacity(white, 0) 
      strokeColor: opacity(black, 0)
      `,
      table: 'demo2016_ad_centroids'
    }
  },
  statisticsVariables: [
    { type: 'statistics', id: 'population', variableIds: ['r1'], config: 'viewportSum(clusterAvg($r1))' },
    { type: 'statistics', id: 'houseCount', variableIds: ['r51'], config: 'viewportSum(clusterAvg($r51))' },
    { type: 'statistics', id: 'incomeAvg', variableIds: ['r742'], config: 'viewportAvg(clusterAvg($r742))' },
    ...revenueVariables.map(variable =>
      ({ type: 'statistics', id: 'revenu_' + variable, variableIds: [ variable, 'r759' ], config: `viewportAvg(clusterSum($${variable}) / clusterSum($r759)* 100)` })
    ),
    ...ageVariables.map(variable =>
      ({ type: 'statistics', id: 'age_' + variable, variableIds: [ variable, 'r8' ], config: `viewportAvg(clusterSum($${variable}) / clusterSum($r8)* 100)` })
    ),
    { type: 'salesAggregation', id: 'customerCount', variableIds: ['null'], config: 'viewportCount($count)' },
    { type: 'salesAggregation', id: 'spentSum', variableIds: ['null'], config: 'viewportSum($total_spent)' },
    { type: 'salesAggregation', id: 'orderSum', variableIds: ['null'], config: 'viewportSum($total_orders)' }
  ]
}
